import {
    FETCH_ORDERS_REQUESTED,
    FETCH_ORDERS_SUCCEED,
    FETCH_ORDERS_FAIL,
    FETCH_ORDER_REQUESTED,
    FETCH_ORDER_SUCCEED,
    FETCH_ORDER_FAIL,
    EDIT_ORDER_REQUESTED,
    EDIT_ORDER_SUCCEED,
    EDIT_ORDER_FAIL,
    VERIFY_ORDER,
    CANCEL_ORDER,
    UPDATE_ORDER,
} from './actionTypes';

const OrdersErrors = {
    fetchOrdersFailed: 'Не удалось обновить список заказов.',
    editOrderFailed: 'Не удалось сохранить данные заказа.'
}

export function fetchOrdersRequested(params) {
    return {
        type: FETCH_ORDERS_REQUESTED,
        payload: params,
    };
}

export function fetchOrdersSucceeded(params) {
    return {
        type: FETCH_ORDERS_SUCCEED,
        payload: params,
    };
}

export function fetchOrdersFailed(params) {
    return {
        type: FETCH_ORDERS_FAIL,
        payload: params,
    };
}

export function editOrderRequested(params) {
    return {
        type: EDIT_ORDER_REQUESTED,
        payload: params,
    };
}

export function editOrderSucceeded(params) {
    return {
        type: EDIT_ORDER_SUCCEED,
        payload: params,
    };
}

export function editOrderFailed(params) {
    return {
        type: EDIT_ORDER_FAIL,
        payload: params,
    };
}

export function verifyOrder(params) {
    return {
        type: VERIFY_ORDER,
        payload: params,
    };
}

export function cancelOrder(params) {
    return {
        type: CANCEL_ORDER,
        payload: params,
    };
}
export function updateOrder(params) {
    return {
        type: UPDATE_ORDER,
        payload: params,
    };
}



// WEBPACK FOOTER //
// ./src/store/orders/actions.js